/*
  Product pages: show the Google reviews that mention this dress's occasion first.

  These are reviews of the boutique, not of one dress, and the block says so. This script only decides the
  ORDER the widget starts in and keeps the first 24 so the page stays light. No review is reworded.
  Order: reviews that mention this dress's occasion (the ones only about that occasion ahead of the ones that
  mention several), then reviews that name its designer, then reviews that mention no occasion, then the rest;
  newest first within each. The line "Reviews that mention … are shown first." is added only when at least two
  of the reviews really contain one of the occasion words. The slider's auto-advance is switched off whenever the
  order has been set here, so the leading reviews stay in view (arrows and swipe still work).

  How it works: the Trustindex loader swaps its <script> for a placeholder <div>, downloads the widget's HTML
  into placeholder.contentHtml, and only builds the slider once the shopper gets near it. The review cards are
  re-ordered inside that HTML before the slider exists, so Trustindex builds it in the right order and all of
  its own behaviour (arrows, photos, "read more") is untouched. If the slider is already built when this runs,
  or the HTML isn't shaped as expected, nothing is changed and the widget shows newest first as usual.

  The words to look for come from sections/reviews.liquid (data-rel-terms; a leading "~" marks a weaker match).
  This file is loaded just before the loader's own <script>, inside the same .reviews__embed, so it is always
  watching by the time the loader puts its placeholder in.
*/
(function () {
  'use strict';

  var KEEP = 24;
  // The shop's own name contains "prom" and "bridal" (Prom Dollz & Bridal, DOLLZ Prom, Homecoming & Bridal);
  // it must not count as a mention of the occasion.
  var SHOP_NAME = /prom[\s-]*doll[zs](?:\s*(?:&|and)\s*bridal(?![a-z0-9]))?|doll[zs][\s-]+(?:bridal|prom)(?![a-z0-9])(?:\s*(?:,\s*(?:and\s+)?|&|and)\s*(?:prom|bridal|homecoming|hoco)(?![a-z0-9]))*/gi;
  // Words that are part of some designer names but are far too common in reviews to mean the designer.
  var TOO_COMMON = ['colors', 'dress', 'dresses', 'prom', 'evening', 'bridal', 'couture'];
  // Every occasion a review can be about. The ones that aren't this dress's count against a review, so a
  // review that is only about this occasion comes before one that mentions it in passing.
  var OCCASIONS = ['prom', 'homecoming', 'hoco', 'bridal', 'wedding', 'bride', 'brides', 'bridesmaid', 'bridesmaids',
    'bridal party', 'mother of the bride', 'mother of the groom', 'pageant', 'pageants', 'flower girl',
    'flower girls', 'communion'];

  function pattern(words, flags) {
    var parts = words.map(function (w) {
      return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '[\\s-]+');
    });
    return parts.length ? new RegExp('(?:^|[^a-z0-9])(?:' + parts.join('|') + ')(?![a-z0-9])', flags || 'i') : null;
  }

  function designerNames(vendor) {
    if (!vendor || /dollz/i.test(vendor)) return [];
    var spaced = vendor.replace(/([A-Z]{2,})([a-z])/g, '$1 $2').toLowerCase().trim(); // "ASHLEYlauren" → "ashley lauren"
    var names = [vendor.toLowerCase().trim(), spaced];
    var by = spaced.split(/\s+by\s+/);
    if (by.length === 2) names.push(by[1]); // "jvn by jovani" → "jovani"
    names.push(spaced.replace(/\s+(?:couture|prom|minis|bridesmaids|dress)$/, '')); // "portia and scarlett couture"
    names = names.concat(names.map(function (n) { return n.replace(/\s+and\s+/g, ' & '); }));
    return names.filter(function (n, i, all) {
      return n.length >= 5 && TOO_COMMON.indexOf(n) === -1 && all.indexOf(n) === i;
    });
  }

  // The reviewer's own words only: not the photo strip, not an owner's reply, not a translation data block.
  function reviewText(body) {
    var text = '';
    for (var node = body.firstChild; node; node = node.nextSibling) {
      if (node.nodeType === 3) { text += node.nodeValue; continue; }
      if (node.nodeType !== 1) continue;
      if (node.classList.contains('ti-reply-by-owner-title')) break;
      if (node.tagName === 'BR') { text += '\n'; continue; }
      if (node.tagName === 'SCRIPT' || node.classList.contains('ti-review-image')) continue;
      text += ' ' + node.textContent + ' ';
    }
    return text;
  }

  function init(box) {
    if (box.querySelector('.ti-widget')) return;

    var strong = [];
    var weak = [];
    (box.getAttribute('data-rel-terms') || '').split('|').forEach(function (term) {
      term = term.trim().toLowerCase();
      if (!term) return;
      if (term.charAt(0) === '~') weak.push(term.slice(1)); else strong.push(term);
    });
    // One list, longest phrase first, so "mother of the bride" is read as that and not as "bride".
    var known = OCCASIONS.concat(strong, weak).filter(function (w, i, all) { return all.indexOf(w) === i; });
    known.sort(function (a, b) { return b.length - a.length; });
    var occasionRe = pattern(known, 'gi');
    var designerRe = pattern(designerNames(box.getAttribute('data-rel-vendor') || ''));

    // points: does the review mention this dress's occasion (4), its designer (2), a related word (1).
    // focus: how much it is about this occasion rather than another one; orders reviews with equal points.
    function rate(text) {
      text = text.replace(SHOP_NAME, ' ');
      var own = 0;
      var related = 0;
      var elsewhere = 0;
      var hit;
      occasionRe.lastIndex = 0;
      while ((hit = occasionRe.exec(text))) {
        var word = hit[0].replace(/^[^a-z0-9]/i, '').toLowerCase().replace(/[\s-]+/g, ' ');
        if (strong.indexOf(word) !== -1) own++;
        else if (weak.indexOf(word) !== -1) related++;
        // A longer phrase built on one of this dress's own words ("bridal party" on a bridal dress) is neither
        // a match nor another occasion.
        else if (!strong.some(function (s) { return (' ' + word + ' ').indexOf(' ' + s + ' ') !== -1; })) elsewhere++;
      }
      var designer = !!designerRe && designerRe.test(text);
      // With no occasion to look for (a plain "Dress"), other occasions don't count against a review either.
      var focus = strong.length || weak.length ? own - elsewhere : 0;
      return { points: (own ? 4 : 0) + (designer ? 2 : 0) + (related ? 1 : 0), focus: focus, own: own };
    }

    // Returns the widget HTML with the review cards re-ordered, or null to leave it exactly as it came.
    function reorder(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (doc.head.childElementCount) return null;
      var widget = doc.querySelector('.ti-widget');
      var wrap = widget && widget.querySelector('.ti-reviews-container-wrapper');
      // Avatar sprites are placed by each card's position, so a widget that uses them is left alone.
      if (!wrap || widget.querySelector('[class*="sprite"]')) return null;
      var cards = Array.prototype.slice.call(wrap.children);
      // Only the plain slider is handled: every child must be an ordinary review card, and layouts that
      // number their cards (data-index — the grid) place them by that number, so they are left alone.
      if (cards.length < 2) return null;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (!card.classList.contains('ti-review-item') || card.classList.contains('ti-ai-summary-item') ||
            card.hasAttribute('data-index')) return null;
      }

      var ranked = cards.map(function (card, index) {
        var body = card.querySelector('.ti-review-content, .ti-review-text-container');
        var rated = rate(body ? reviewText(body) : '');
        return { card: card, index: index, points: rated.points, focus: rated.focus, own: rated.own };
      });
      var anyMatch = ranked.some(function (r) { return r.points > 0; });
      if (!anyMatch && ranked.length <= KEEP) return null;

      ranked.sort(function (a, b) { return b.points - a.points || b.focus - a.focus || a.index - b.index; });
      var kept = ranked.slice(0, KEEP);
      wrap.textContent = '';
      kept.forEach(function (r) { wrap.appendChild(r.card); });
      var named = kept.filter(function (r) { return r.own > 0; }).length;

      // Photo data is matched to cards by review id; drop the entries whose card is no longer in the slider.
      var photos = widget.querySelector('script.ti-lightbox-data');
      if (photos) {
        try {
          var keptIds = {};
          kept.forEach(function (r) { keptIds[r.card.getAttribute('data-id')] = true; });
          var data = JSON.parse(photos.textContent);
          if (data && Array.isArray(data.data)) {
            data.data = data.data.filter(function (entry) { return keptIds[entry.r]; });
            photos.textContent = JSON.stringify(data);
          }
        } catch (e) { /* leave the photo data as it came */ }
      }

      // The order was chosen for the shopper, so the slider shouldn't move on by itself every 6 seconds.
      // (The attribute has to stay — the loader only builds the slider when it is present; "0" means no timer.)
      if (widget.hasAttribute('data-pager-autoplay-timeout')) {
        widget.setAttribute('data-pager-autoplay-timeout', '0');
      }
      return { html: doc.body.innerHTML, named: named };
    }

    var noted = false;
    function note(named) {
      var label = box.getAttribute('data-rel-label');
      var section = box.closest('.reviews');
      var sub = section && section.querySelector('[data-rel-sub]');
      // "Reviews … are shown first" is plural: say it only when at least two of them really do.
      if (noted || named < 2 || !label || !sub || !box.isConnected) return;
      noted = true;
      sub.textContent = sub.textContent.trim() + ' Reviews that mention ' + label + ' are shown first.';
    }

    function sorted(html) {
      try {
        var result = reorder(html);
        if (!result) return html;
        note(result.named);
        return result.html;
      } catch (e) {
        return html;
      }
    }

    // The placeholder is the <div> the loader puts where its <script> was; it carries the widget id as .key.
    function placeholder() {
      for (var i = 0; i < box.children.length; i++) {
        var el = box.children[i];
        if (el.tagName === 'DIV' && typeof el.key === 'string' && !el.classList.contains('ti-widget')) return el;
      }
      return null;
    }

    function arm(holder) {
      if (holder.pdRelevance) return;
      holder.pdRelevance = true;
      if (typeof holder.contentHtml === 'string') {
        holder.contentHtml = sorted(holder.contentHtml);
        return;
      }
      // The HTML hasn't arrived yet: sort it at the moment the loader stores it.
      var stored;
      try {
        Object.defineProperty(holder, 'contentHtml', {
          configurable: true,
          enumerable: true,
          get: function () { return stored; },
          set: function (value) { stored = typeof value === 'string' ? sorted(value) : value; }
        });
      } catch (e) { /* leave the widget as it is */ }
    }

    var holder = placeholder();
    if (holder) { arm(holder); return; }

    // The loader hasn't run yet: wait for it to put its placeholder in.
    if (!('MutationObserver' in window)) return;
    var watcher = new MutationObserver(function () {
      var found = placeholder();
      if (found) arm(found);
      if (found || box.querySelector('.ti-widget')) watcher.disconnect();
    });
    watcher.observe(box, { childList: true });
  }

  function run() {
    var boxes = document.querySelectorAll('.reviews__embed[data-rel-terms]');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].pdRelevanceBox) continue;
      boxes[i].pdRelevanceBox = true;
      init(boxes[i]);
    }
  }

  run();
  // The theme editor re-renders the section without re-running this file.
  if (!window.pdRelevanceListening) {
    window.pdRelevanceListening = true;
    document.addEventListener('shopify:section:load', run);
  }
})();
